import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { QaiAlertComponent, QaiButtonComponent } from '@qai/ui';
import { filter } from 'rxjs';
import { SimulationGenerationPollingService } from 'src/app/services/self-serve/simulation-generation-polling.service';
import { SimulationGenerationStatus } from 'src/app/utils/enums/self-serve/simulation-generation-status.enum';

@Component({
  selector: 'simulation-generation-banner-host',
  standalone: true,
  templateUrl: './simulation-generation-banner-host.component.html',
  styleUrls: ['./simulation-generation-banner-host.component.scss'],
  imports: [QaiAlertComponent, QaiButtonComponent, TranslocoModule],
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: 'simulationBuilder' }],
})
export class SimulationGenerationBannerHostComponent {
  private pollingService = inject(SimulationGenerationPollingService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  readonly SimulationGenerationStatus = SimulationGenerationStatus;
  notifications = this.pollingService.terminalGenerations;
  readonly ready = signal(false);
  readonly isInSelfServeArea = signal(this.router.url.startsWith('/self-serve'));

  constructor() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((event) => {
        this.ready.set(true);
        this.isInSelfServeArea.set(event.urlAfterRedirects.startsWith('/self-serve'));
      });
  }

  dismiss(callUuid: string): void {
    this.pollingService.dismiss(callUuid);
  }

  handleViewSimulationClick(
    callUuid: string,
    moduleUuid?: string,
    simulationStatus?: string,
  ): void {
    this.dismiss(callUuid);
    this.router.navigate(['/self-serve/simulations', callUuid], {
      queryParams: { moduleUuid, status: simulationStatus },
    });
  }

  handleViewDocumentsClick(callUuid: string): void {
    this.dismiss(callUuid);
    this.router.navigate(['/self-serve'], {
      queryParams: { retrySimulationCallUuid: callUuid },
    });
  }
}
